/**
 * @file Application entry point.
 *
 * Bootstraps the React app inside an XmplProvider (Circle personalisation)
 * and a BrowserRouter scoped to the `/XMPieSecurity` base path so the
 * build can be deployed at `https://marketingy.xmpie.net/XMPieSecurity`.
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { XmplProvider } from 'xmpl-react';
import App from './App';
import './index.css';

/** Circle campaign configuration passed to XmplProvider. */
const xmpcfg = {
  access: {
    accessToken: 'fead9edc-c6a4-499e-96aa-c191e7b7fb98_718401c0-4452-4516-ac61-1baef7a39978_5183b509b94e4676adcf6cf378c02093',
    url: 'https://marketingy.xmpie.net/XMPieXMPL_REST_API',
    circleProjectID: '718401c0-4452-4516-ac61-1baef7a39978',
    circleProjectName: 'XMPie Security Comformance'
  }
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <XmplProvider xmpcfg={xmpcfg}>
      <BrowserRouter basename="/XMPieSecurity">
        <App />
      </BrowserRouter>
    </XmplProvider>
  </React.StrictMode>
);
